module.exports = __webpack_public_path__ + "static/media/daycareSupervisionIcon.604ec258.png";